module.exports = __webpack_public_path__ + "img/king-capture-multiple.db4ad0de.gif";